export class EmailLog {
    constructor(emailLogState) {
        this.emailLogState = emailLogState;
    }
    get id() { return this.emailLogState.id; }
    get destinatary() { return this.emailLogState.destinatary; }
    get cc() { return this.emailLogState.cc; }
    get bcc() { return this.emailLogState.bcc; }
    get subject() { return this.emailLogState.subject; }
    get content() { return this.emailLogState.content; }
    get date_created() { return this.emailLogState.date_created; }
    set id(id) { this.emailLogState.id = id; }
    set destinatary(destinatary) { this.emailLogState.destinatary = destinatary; }
    set cc(cc) { this.emailLogState.cc = cc; }
    set bcc(bcc) { this.emailLogState.bcc = bcc; }
    set subject(subject) { this.emailLogState.subject = subject; }
    set content(content) { this.emailLogState.content = content; }
    set date_created(date_created) { this.emailLogState.date_created = date_created; }
    getState() { return this.emailLogState; }
}
